export const partners = [
  {
    name: "Abu Dhabi National Oil Company",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/ADNOC_Logo.webp",
  },
  {
    name: "Expro International Group Ltd",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/EXPRO_Logo.webp",
  },
  {
    name: "Cummins Inc",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Cummins_Logo.webp",
  },
  {
    name: "Siemens",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Siemens_Logo.webp",
  },
  {
    name: "Dubai Petroleum and Dubai Supply Authority",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Dubai_Petroleum_and_Dubai_Supply_Authority_Logo.webp",
  },
  {
    name: "Al Bahar CAT",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Al-Bahar_CAT_Logo.webp",
  },
  {
    name: "Olayan Energy Ltd",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Olayan_Energy_Logo.webp",
  },
  {
    name: "Motoren- und Turbinen-Union (MTU)",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Motoren-_und_Turbinen-Union_MTU__Logo.webp",
  },
  {
    name: "Jakson Group",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Jakson_Group_Logo.webp",
  },
  {
    name: "Kanoo Energy",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Kanoo_Energy_Logo.webp",
  },
  {
    name: "Energia",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Energia_Logo.webp",
  },
  {
    name: "Peax Equipment Rental",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Peax_Logo.webp",
  },
  {
    name: "WT Petrotech USA",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/WT_Petrotech_USA_Logo.webp",
  },
  {
    name: "Webuild",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Webuild_Logo.webp",
  },
  {
    name: "Bifco",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Bifco_Logo.webp",
  },
  {
    name: "Intech",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Intech_Logo.webp",
  },
  {
    name: "Versar",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Versar_Logo.webp",
  },
  {
    name: "Al-Sultan & Khalaf Trading Co",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Al-Sultan_Khalaf_Trading_Co_Logo.webp",
  },
  {
    name: "Danway Group",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Danway_Logo.webp",
  },
  {
    name: "Hunter",
    logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Hunter_Logo.webp",
  },
];